module.exports = __webpack_public_path__ + "img/product-m-banner.166217b1.png";